import { Injectable, inject } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { ChartSummary } from '@models/chart-summary.interface';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class ChartsService {
  private readonly apiService = inject(ApiService);
  private listCache$?: Observable<ChartSummary[]>;

  getList(forceRefresh = false): Observable<ChartSummary[]> {
    if (forceRefresh || !this.listCache$) {
      this.listCache$ = this.apiService
        .get('charts')
        .pipe(shareReplay(1));
    }

    return this.listCache$;
  }

  create(chartName: string, file: File): Observable<ChartSummary> {
    const formData = new FormData();
    formData.append('chartName', chartName);
    formData.append('file', file, file.name);

    return this.apiService.post('charts', formData);
  }

  delete(id: number): Observable<void> {
    this.listCache$ = undefined;
    return this.apiService.delete(`charts/${id}`);
  }
}